// extracted by mini-css-extract-plugin
export default {"component":"hH2Jr"};